import Settings from './Settings';

export const SURVEY_ID_LIST = {
  CONTENT_MANAGEMENT: '60fd6d9f0622aad6',
  CLASSES: 'd4c4a0bfbe663edb',
  CERTIFICATE: 'f7ed8ac1e494d85b',
  QUIZ: '30b2971367de4854',
  LEGACY_REDIRECT_ALERT: 'b870726aeb3a5366',
  SURVEY_THIRDY_PRODUCTS: '8f954f4f544f1418',
  SURVEY_NON_ADOPTION_NEW_CLUB: '7cb4ff08a84588d1',
  SURVEY_MENTORSHIP_EXPERIMENT: '93568e99f49340c5'
};

export const SURVEY_EVENTS = {
  PLAYER_CHURN: 'streamingDeactivate',
  DRIPPING_BY_CLASS: 'dripping_new_single',
  BULK_DRIPPING_BY_CLASS: 'dripping_new_bulk',
  MODULE_CREATE: 'module_create',
  OLD_MODULE_CREATE: 'old_module_create',
  OLD_CONTENT_CREATE: 'old_content_create'
};

const setSurvicateData = (user = {}) => {
  window._sva?.setVisitorTraits?.({
    id: user.marketplaceId,
    locale: user.locale
  });
};

const devLogMessage = (message, ...optionalParams) => {
  if (!Settings.isProduction()) {
    // eslint-disable-next-line no-console
    console.log(message, ...optionalParams);
  }
};

export const showSurvey = (surveyId, options = {}) => {
  window._sva?.showSurvey?.(surveyId, options);

  devLogMessage(
    `The survicate show survey method was triggered for: ${surveyId}`,
    options
  );
};

export const invokeEvent = (surveyEvent) => {
  window._sva?.invokeEvent?.(surveyEvent);

  devLogMessage(
    `The survicate invoke method was triggered for: ${surveyEvent}`
  );
};

export default setSurvicateData;
